import React from 'react';

import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onReset, customerLocations = [], customers = [] }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'available', label: 'Available' },
    { value: 'busy', label: 'Busy' },
    { value: 'offline', label: 'Offline' }
  ];

  const sortOptions = [
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'rating', label: 'Rating (Highest)' }
  ];

  const customerOptions = [
    { value: 'all', label: 'All Customers' },
    ...customers?.map(c => ({ value: c?.id, label: c?.name }))
  ];

  const wellNameOptions = [
    { value: 'all', label: 'All Well Names' },
    ...customerLocations
      ?.filter(loc => filters?.locationCustomer === 'all' || loc?.customer_id === filters?.locationCustomer)
      ?.map(loc => ({ value: loc?.id, label: loc?.well_name }))
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Filters
        </h3>
        <button
          onClick={onReset}
          className="text-sm text-primary hover:text-primary/80 font-medium transition-smooth"
        >
          Reset All
        </button>
      </div>
      <Input
        type="search"
        placeholder="Search technicians..."
        value={filters?.search}
        onChange={(e) => onFilterChange('search', e?.target?.value)}
        iconName="Search"
      />
      <Select
        label="Status"
        options={statusOptions}
        value={filters?.status}
        onChange={(value) => onFilterChange('status', value)}
      />
      <Select
        label="Sort By"
        options={sortOptions}
        value={filters?.sortBy}
        onChange={(value) => onFilterChange('sortBy', value)}
      />

      {/* Location Filtering Section */}
      <div className="border-t border-border pt-4">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-3">Location Filters</p>
        <div className="space-y-3">
          <Select
            label="Customer"
            options={customerOptions}
            value={filters?.locationCustomer || 'all'}
            onChange={(value) => {
              onFilterChange('locationCustomer', value);
              onFilterChange('locationWell', 'all');
            }}
          />
          <Select
            label="Well Name"
            options={wellNameOptions}
            value={filters?.locationWell || 'all'}
            onChange={(value) => onFilterChange('locationWell', value)}
          />
        </div>
      </div>

      <Checkbox
        label="Show only technicians with availability today"
        checked={filters?.availableToday}
        onChange={(e) => onFilterChange('availableToday', e?.target?.checked)}
      />
    </div>
  );
};

export default FilterPanel;